import { Offcanvas } from "bootstrap";
import { setCookie, getCookie, clearCookie } from "../utils/cookie";

export default class CookieInfoLink extends HTMLAnchorElement {

    connectedCallback() {
        this.addEventListener("click", this.handleClick);        
    }

    handleClick = (e) => {

        e.preventDefault();

        // Reset cookie closed cookie
        clearCookie("cookieinfo-closed-v4");

        // Fetch the current pages HTML code and update it
        fetch(location.href).then(function (response) {
            return response.text();
        }).then(function (data) {

            // get the content of body
            const match = data.match(/<body>([\s\S]*?)<\/body>/im);

            // Update page HTML to add cookie info
            if (match.length >= 2)
                document.body.innerHTML = match.pop();

            // Display cookie info message again
            let cookieInfo = new Offcanvas(document.querySelector("#cookie-info"));
            cookieInfo.show();

        });

    }

}

customElements.define('cookie-info-link', CookieInfoLink, { extends: 'a' });